import * as request from '@/utils/request'

/**
 * @description 获取角色【工作流】
 * @param {*} data
 * @returns
 */
export function getWorkflowRoles(data) {
  return request.get('/workflow/roles', data)
}

/**
 * @description 获取角色【工作流】
 * @param {*} data
 * @returns
 */
export function getWorkFlowDepartments(data) {
  return request.get('/workflow/departments', data)
}

/**
 * @description 获取人员【工作流】
 * @param {*} data
 * @returns
 */
export function getWorkFlowEmployees(data) {
  return request.get('/workflow/employees', data)
}
/**
 * @description 获取人员【工作流】
 * @param {*} data
 * @returns
 */
export function getWorkFlowConditions(data) {
  return request.get('/workflow/conditions', data)
}

/**
 * @description 获取配置数据【工作流】
 * @param {*} data
 * @returns
 */
export function getWorkFlowData(data) {
  return request.get('/workflow/data', data)
}

/**
 * @description 保存配置数据【工作流】
 * @param {*} data
 * @returns
 */
export function setWorkFlowData(data) {
  return request.post('/workflow/save', data)
}
